// General

var school_manager_email_group = $(".project_school_manager_email");

function invalidEmail(email) {
  return (
    !email ||
    email.length === 0 ||
    !email.match(
      /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/
    )
  );
}

function updateEmailField(schools_container) {
  const selected = schools_container.find(".school-selected");
  const email = $.trim(selected.find(".school_email").text());

  if (selected.length === 1 && invalidEmail(email))
    school_manager_email_group.show().find("input").attr("required", true);
  else
    school_manager_email_group
      .hide()
      .find("input")
      .val("")
      .removeAttr("required");
}

function emptySchoolsContainer(schools_container) {
  schools_container.find(".school-results").html("");
  schools_container.find(".loading-gif").hide();
}

function updateView(schools_container, record_id_field) {
  schools_container.find(".loading-gif").hide(); // Launching loading GIF

  const schools = schools_container.find(".school-container");
  const nbSchools = schools.length;

  if (nbSchools === 1) {
    schools.addClass("school-selected");
    $(record_id_field).val("");
  } else {
    schools.addClass("school-radio");

    const record_id = $(record_id_field).val();
    if (record_id.length > 0) {
      const elem = schools_container.find("#" + record_id);

      if (elem.length === 1) elem.addClass("school-selected");
      else $(record_id_field).val("");
    }
  }

  updateEmailField(schools_container);
}

function refreshSchoolResults(
  school_reference_field,
  schools_container,
  record_id_field
) {
  var reference = $(school_reference_field).val().toUpperCase();

  if (reference.length === 8) {
    $(school_reference_field).val(reference); // Update field value to uppercase

    emptySchoolsContainer(schools_container);
    schools_container.find(".loading-gif").css("display", "block"); // Launching loading GIF

    var url = "/education_gouv/schools?reference=" + reference;

    $.get(url, function (data) {
      schools_container.find(".school-results").html(data);
      updateView(schools_container, record_id_field);
    });
  }
}

function selectSchool(record_id_field, schools_container, selected_school) {
  if ($(selected_school).hasClass("school-selected")) {
    return;
  }

  schools_container.find(".school-select-hint").remove(); // Hide selection hint
  schools_container.find(".school-selected").removeClass("school-selected"); // Remove previous selection
  $(selected_school).addClass("school-selected"); // Select element
  $(record_id_field).val(selected_school.id); // Insert its id into record_id input

  updateEmailField(schools_container);
}

function checkBeforeGeneralSubmit(schools_container) {
  if (schools_container.find(".school-selected").length === 1) {
    return true;
  } else {
    const hint = schools_container.find(".school-select-hint");

    if (!hint.hasClass("error")) {
      hint.addClass("error");
    }
    hint.show();

    return false;
  }
}

// Structure
$(document).ready(function () {
  var general_forms = $("form.project-general-form");

  // General
  general_forms.each(function () {
    var form = $(this);
    var school_reference_field = form.data("schoolReference");
    var schools_container = $(form.data("schoolsContainer"));
    var record_id_field = form.data("projectSchoolRecordId");

    $(school_reference_field).keyup(() =>
      refreshSchoolResults(
        school_reference_field,
        schools_container,
        record_id_field
      )
    );
    schools_container.on("click", "div.school-radio", (event) =>
      selectSchool(record_id_field, schools_container, event.currentTarget)
    );

    form.submit(() => checkBeforeGeneralSubmit(schools_container));

    $(school_reference_field).each(() =>
      refreshSchoolResults(
        school_reference_field,
        schools_container,
        record_id_field
      )
    );
    updateEmailField(schools_container);
  });

  $(".js-show-more").on("click", function () {
    $(this)
      .parent()
      .find(".js-clamp-text")
      .removeClass("max-lg-line-clamp-5 max-sm-line-clamp-5");
    $(this).addClass("d-none");
  });
});
